import React from 'react';
import { compose, withProps } from 'recompose';
import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps';

const styles = [
  {
    featureType: 'poi.attraction',
    stylers: [
      {
        color: '#3785eb',
      },
      {
        lightness: 10,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.medical',
    stylers: [
      {
        lightness: 25,
      },
    ],
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit.station',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit.station.bus',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

class GoogleMapComponent extends React.Component {
  render () {
    const {
      children,
      options,
      onMapLoaded,
      defaultCenter = { lat: 10.7779631, lng: 106.6877743 },
      ...rest
    } = this.props;

    return (
      <GoogleMap
        defaultZoom={14}
        defaultCenter={defaultCenter}
        options={{ ...options, styles }}
        ref={onMapLoaded}
        {...rest}
      >
        {children}
      </GoogleMap>
    );
  }
}

export default compose(
  withProps((props) => {
    const { height, width } = props;
    const mHeight = height || 400;
    const mWidth = width || '100%';
    const containerElement = <div style={{ height: mHeight, width: mWidth }} />;
    return {
      googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${CONFIG.GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places&language=${CONFIG.LANG}&region=${CONFIG.REGION}`,
      loadingElement: <div style={{ height: '100%' }} />,
      mapElement: <div style={{ height: '100%' }} />,
      containerElement,
    };
  }),
  withScriptjs,
  withGoogleMap,
)(GoogleMapComponent);
